import { DEFAULT_THEME_STYLE, Theme } from './constants';
import { IVideoStyle } from './types';

const THEME_PRESETS: Record<string, [string, string, string]> = {
  [Theme.POSH]: ['Cervo', '#D6E6FF', '#ECEF2C'],
  [Theme.EDGY]: ['ProximaNova', '#FEFFAD', '#0C6645'],
  [Theme.MINIMAL]: ['Cervo', '#555555', '#DCE7FF'],
  [Theme.TRIGONO]: ['ProximaNova', '#EADECE', '#3E3E3E'],
  [Theme.FASHION]: ['NotoSerif', '#FFCECE', '#f96132'],
  [Theme.SALE]: ['Rubik', '#EB4B10', '#FFFFFF'],
  [Theme.KIDS]: ['Sensei', '#EB4B10', '#7BF0CB'],
  [Theme.DUOTONE]: ['RobotoSlab', '#DCE7FF', '#304980'],
  [Theme.BRUSHSTROKE]: ['Rubik', '#FF6A1A', '#FFF769'],
};

function getThemeStyle(themeName: string): IVideoStyle {
  if (!THEME_PRESETS[themeName]) {
    return DEFAULT_THEME_STYLE;
  }

  const [activeFont, primaryColor, secondaryColor] = THEME_PRESETS[themeName];

  return {
    activeFont,
    primaryColor,
    secondaryColor,
  };
}

export { getThemeStyle };
